import { Button } from "@radix-ui/themes";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";
import {
  DateRange,
  DateRangePicker,
} from "@/components/shared/date-range-picker/DateRangePicker";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TrackerColumn, Tracker } from "@/v2/entities/tracker/Tracker.model";
import styles from "../trackerDetail.module.scss";

interface TrackerActionRowProps {
  dateRange: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
  columns: TrackerColumn[];
  hiddenColumns: Set<string>;
  onToggleColumn: (col: string) => void;
  tracker: Tracker;
}

export function TrackerActionRow({
  dateRange,
  onDateRangeChange,
  columns,
  hiddenColumns,
  onToggleColumn,
}: TrackerActionRowProps) {
  const hiddenCount = hiddenColumns.size;
  const allVisible = hiddenCount === 0;
  return (
    <div className={styles.trackerDetailActionRow}>
      <div className={styles.trackerDetailActionRow__right}>
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Button variant="ghost" color="gray" size="2">
              {allVisible ? <EyeOpenIcon /> : <EyeClosedIcon />}
              {hiddenCount === 0
                ? "No hidden columns"
                : `${hiddenCount} hidden column${hiddenCount > 1 ? "s" : ""}`}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {columns.map((col) => (
              <DropdownMenuCheckboxItem
                key={col.name}
                checked={!hiddenColumns.has(col.name)}
                onCheckedChange={() => onToggleColumn(col.name)}
              >
                {col.name}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        <DateRangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          hideRange
          size="2"
        />
      </div>
    </div>
  );
}
